import * as React from "react";
import { SVGProps, Ref, forwardRef, memo } from "react";
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#111"
        fillOpacity={0.44}
        d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm0 7.333c-.736 0-1.333.598-1.333 1.334v2a1.333 1.333 0 0 0 2.666 0v-2c0-.736-.597-1.334-1.333-1.334ZM8 4a1.333 1.333 0 1 0 0 2.666A1.333 1.333 0 0 0 8 4Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
